import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'vb-widgets-lists-6',
  templateUrl: './6.component.html',
  styleUrls: ['./6.component.scss'],
})
export class VbList6Component implements OnInit {
  constructor() {}
  ngOnInit() {}
}
